import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { SliderReusableComponent } from "../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal, Button, Row, Col, Image } from "react-bootstrap";
import { IconButton } from "@material-ui/core";
import axios from "axios";
import Alert from "react-s-alert";
import { serverApi } from "../../../../../../../config/Keys";
import { NewInputText } from "../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import InputNumberFunc from "../../../../../../../function/InputNumberFunc";
import {
  InputCharNumFunc,
  InputCharacterCheck,
  InputCharNumSpaceFunc,
} from "../../../../../../../function/InputCharNumCheckFunc";
import country from "../../../../../../localization/country.json";
import SimpleReactLightbox from "simple-react-lightbox";
import {
  MultipleImageUploadComponent,
  MultipleImageUploadShowComponent,
} from "../../../../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { AddButtonIconComponent } from "../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";

import { useFormik } from "formik";
import * as yup from "yup";
import LeftSideNavigation from "../../../../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../../../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../../../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../../../../navigationSection/BottomNavigationMobile";

import {
  update_new_subscription_for_vendor,
  razor_create_fund_account,
  razor_validate_fund_account,
  razor_create_sub_merchant_account,
} from "../../../../../../../store/actions/authAction";
import { AmealioLoader } from "../../../../../../Loader/AmealioLoader";
import { ToggleButtonWithYesNo } from "../../../AllButton/ToggleButtonReuse";
import Media from "react-media";
import { MobileTopHeader } from "../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";

const ifsc = /^[A-Z]{4}0[A-Z0-9]{6}$/;

const validationSchema = yup.object({
  bankName: yup
    .string()
    .required("Bank name is required")
    .min(3, "Name must be atleast 3 characters")
    .max(120, "Name mustnot exceed 120 characters"),
  account_type: yup.string().required("Please select account type"),
  email: yup
    .string()
    .email("Please enter valid Email address")
    .required("Please enter your email"),

  account_number: yup
    .string()
    .required("Account number is required")
    .matches(/^[0-9]+$/, "Must be only digits")
    .min(6, "Account number must be between 6-20 digits")
    .max(20, "Must be exactly 20 digits"),
  re_account_number: yup
    .string()
    .required("Please re-enter your account number")
    .matches(/^[0-9]+$/, "Must be only digits")
    .min(6, "Account number must be between 6-20 digits")
    .max(20, "Must be exactly 20 digits")
    .oneOf([yup.ref("account_number"), null], "Account number must match"),
  account_ifsc: yup
    .string()
    .required("Ifsc code is required")
    .matches(ifsc, "Ifsc code is  Invalid")
    .max(11, "Ifsc code should be of atleast 11 characters"),
  account_branch: yup.string().required("Branch name is required"),
});

const validate = (values) => {
  const errors = {};
  if (values.docs.length === 0) {
    errors.docs = "Please upload atleast one supporting document";
  }
  return errors;
};

export const EditFastFoodSeparateBankAccount = (props) => {
  let history = useHistory();
  const [state, setState] = useState({
    editButton: false,
  });
  const [loading, setLoading] = useState(false);
  const [localizationText, setLocalizationText] = useState("");
  const [showDeleteAccount, seShowDeleteAccount] = useState(false);
  const handleCloseAccount = () => {
    seShowDeleteAccount(false);
  };

  var tempEditIndex = -1;

  const onClickDeleteAccount = () => {
    setLoading(true);
    let deleteAccount = bankData.filter((item, index) => {
      return index !== editIndex;
    });

    setEditIndex(-2);
    tempEditIndex = -2;
    const token = props.auth.user.accessToken;
    const subscriptionId = props.subscription._id;

    let formData = props.allSubscriptionsData;
    formData.fast_food_dining_status.ordering.maintain_separate_bank.tips_separate = false;
    formData.fast_food_dining_status.ordering.maintain_separate_bank.addedAccounts =
      deleteAccount;
    props.update_new_subscription_for_vendor(
      subscriptionId,
      formData,
      token,
      onSuccess
    );
    seShowDeleteAccount(false);
    if (deleteAccount.length === 0) {
      setShowForm(true);
    } else {
      setShowForm(false);
    }
    setBankData(deleteAccount);
  };
  const handleShowBAccount = (index) => {
    setEditIndex(index);
    seShowDeleteAccount(true);
    setShowDetails(false);
  };

  const [showTaxSurcharges, setShowTaxSurcharges] = useState(false);
  const handleShowTaxSurcharges = () => {
    setShowTaxSurcharges({
      showTaxSurcharges: !showTaxSurcharges.showTaxSurcharges,
    });
  };

  useEffect(() => {
    setLocalizationText(
      props.auth.user.VendorUser.country_code +
        props.auth.user.VendorUser.country
    );
  }, [props.onboarding.bankName]);

  // const handleSubmit = (e) => {
  //   if (props.onboarding._id && props.auth.user.VendorUser._id) {
  //     const formData = {
  //       vendor_id: this.props.auth.user.VendorUser._id,
  //       id: this.props.onboarding._id,
  //       bankName: this.state.bankName,
  //       account_type: this.state.currentSavingAccount,
  //       account_number: this.state.accountNumber,
  //       account_branch: this.state.branchName,
  //       docs: this.state.panCard,
  //     };
  //     console.log(formData);
  //     // this.props.update_new_subscription_for_vendor(formData);
  //   }
  // };

  /*************************************
   * @DESC Multiple Bank Details Image Upload
   ************************************/
  const [combined, setCombined] = React.useState("");
  const [restaurant_pictures_new, setResPicNew] = React.useState([]);
  const onCompleteUploadMultipleCrop = (e, file) => {
    let oldData = formik.values.docs;
    let newData = e;
    let mergedData = oldData.concat(newData);
    // setBank_Information(mergedData);
    formik.setFieldValue("docs", mergedData);
    let restaurant_pictures_temp = restaurant_pictures_new;

    let newToUpload = restaurant_pictures_temp.filter((item, index) => {
      return item.name !== file.name;
    });
    setResPicNew(newToUpload);
  };

  const bankUploadMultipleFiles = (e) => {
    // this.setState({ bankImageLoader: true });
    const vendor_id = props.auth.user.VendorUser._id;
    const restaurant_name = props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;

    var newUploaded = [];
    var docs = false;
    for (let i = 0; i < e.target.files.length; i++) {
      //let allPicures = docs;
      let allPicures = formik.values.docs;
      allPicures.some((phone) => {
        if (phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name) {
          flag = true;
        }
      });
      if (!flag) {
        if (e.target.files[i].type === "application/pdf") {
          // docs.push(e.target.files[i]);
          docs = true;
          data.append("files", e.target.files[i]);
        } else {
          newUploaded.push(e.target.files[i]);
        }
      }
    }
    if (!flag) {
      setResPicNew(newUploaded);
      setCombined(combined);
      if (docs) {
        axios
          .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
          .then((res) => {
            // let oldData = docs;
            let oldData = formik.values.docs;
            let newData = res.data;
            let mergedData = oldData.concat(newData);
            // setBank_Information(mergedData);
            formik.setFieldValue("docs", mergedData);
            Alert.success(`<h4>Bank Details Image Upload Successfully</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
          })
          .catch((err) => {
            // this.setState({ bankImageLoader: false });
            Alert.error(`<h4>${err}</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
          });
      }
    } else {
      // this.setState({ bankImageLoader: false });
      Alert.error(`<h4>Can not upload the same image</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  const bankDocMultipleRemove = (indexId) => (e) => {
    let allBankDetails = formik.values.docs.filter((item, index) => {
      return index !== indexId;
    });
    formik.setFieldValue("docs", allBankDetails);
    //setBank_Information(allBankDetails);
  };

  const [bankData, setBankData] = useState([
    // {
    //   bankName: "Aman",
    //   account_type: "Current Account",
    //   account_number: "24320100004711",
    //   account_ifsc: "SBIN0000000",
    //   account_branch: "State bank ",
    //   docs: [
    //     "https://amealia.s3.amazonaws.com/5fae764dd45a222572f6fb6d_ParamFood-download%20%281%29.png",
    //     "https://amealia.s3.amazonaws.com/5fae764dd45a222572f6fb6d_ParamFood-download.png",
    //     "https://amealia.s3.amazonaws.com/5fae764dd45a222572f6fb6d_ParamFood-link-informatic_318-10808.jpg",
    //   ],
    // },
  ]);

  const [editIndex, setEditIndex] = useState(-1);
  const [showForm, setShowForm] = useState(false);

  const setDataToFrorm = (data, index) => {
    setShowForm(true);
    formik.setValues(data);
    setEditIndex(index);
    setShowDetails(false);
  };

  const onSuccess = () => {
    setLoading(false);
    let msg = "";
    if (tempEditIndex === -1) {
      msg =
        " Added Successfully, Check your bank account we have credited 1 ₹ in your bank account";
    } else if (tempEditIndex === -2) {
      msg = "Deleted Successfully";
    } else {
      msg = "Edited";
    }
    Alert.success(`<h4>Bank Details ${msg} </h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/edit-ordering-fastfood-subscription/separate-bank-account");
  };

  const formik = useFormik({
    initialValues: {
      bankName: "",
      account_type: "CURRENT",
      account_number: "",
      re_account_number: "",
      email: "",
      account_ifsc: "",
      account_branch: "",
      account_purpose: "TIPS",
      docs: [],
    },
    validationSchema,
    validate,

    onSubmit: (values) => {
      const token = props.auth.user.accessToken;
      //   const subscriptionId = props.subscription._id;

      //   let existingData = [...bankData];
      //   existingData.push(values);
      //   let formData = props.allSubscriptionsData;
      //   formData.fast_food_dining_status.ordering.maintain_separate_bank.tips_separate = true;
      //   //formData.fast_food_dining_status.ordering.maintain_separate_bank.tips_separate = tips_separate;

      //   if (editIndex >= 0) {
      //     let items = [...bankData];
      //     // 2. Make a shallow copy of the item you want to mutate
      //     // let item = { ...items[editIndex] };
      //     // 3. Replace the property you're intested in
      //     //item = values;
      //     // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first

      //     items[editIndex] = values;
      //     formData.fast_food_dining_status.ordering.maintain_separate_bank.addedAccounts = items;
      //     // 5. Set the state to our new copy
      //     //setBankData(items);
      //     props.update_new_subscription_for_vendor(
      //       subscriptionId,
      //       formData,
      //       token,
      //       onSuccess
      //     );
      //     tempEditIndex = 0;
      //     setEditIndex(-1);
      //     formik.resetForm();
      //     setShowForm(false);
      //   } else {
      //     formData.fast_food_dining_status.ordering.maintain_separate_bank.addedAccounts = existingData;
      //     // setBankData([...bankData, values]);
      //     props.update_new_subscription_for_vendor(
      //       subscriptionId,
      //       formData,
      //       token,
      //       onSuccess
      //     );
      //     formik.resetForm();
      //     tempEditIndex = -1;
      //     setShowForm(false);
      //   }
      // },

      let data = {
        contact_id: props.auth.user.VendorUser.razorpay_contect_id,
        account_type: "bank_account",
        bank_account: {
          name: values.bankName,
          ifsc: values.account_ifsc,
          account_number: values.account_number,
        },
      };

      props.razor_create_fund_account(data, token, onSuccessValidateAccount);
    },
  });

  const onSuccessValidateAccount = (fundId) => {
    const token = props.auth.user.accessToken;
    let data = {
      fund_account_id: fundId,
    };

    props.razor_validate_fund_account(data, token, onSuccessSubMerchant);
  };

  const onSuccessSubMerchant = (fundId) => {
    const token = props.auth.user.accessToken;
    let data = {
      name: formik.values.bankName,
      email: formik.values.email,
      business_name: formik.values.bankName,
      ifsc_code: formik.values.account_ifsc,
      beneficiary_name: formik.values.bankName,
      account_number: formik.values.account_number,
      fundId: fundId,
    };
    props.razor_create_sub_merchant_account(
      data,
      token,
      onSuccessCallSubscriptionApi
    );
  };

  const onSuccessCallSubscriptionApi = (fundId, accountId) => {
    const token = props.auth.user.accessToken;
    const subscriptionId = props.subscription._id;
    let formData = props.allSubscriptionsData;
    let existingData = [...bankData];
    let formikValues = JSON.parse(JSON.stringify(formik.values));
    formikValues.fundId = fundId;
    formikValues.accountId = accountId;
    existingData.push(formikValues);
    formData.fast_food_dining_status.ordering.maintain_separate_bank.value = true;
    formData.fast_food_dining_status.ordering.maintain_separate_bank.addedAccounts =
      existingData;
    props.update_new_subscription_for_vendor(
      subscriptionId,
      formData,
      token,
      onSuccess
    );
  };

  // kept for focus
  const [count, setCount] = useState(1);
  const onClickDone = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };
  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  useEffect(() => {
    if (formik.errors && formik.errors.bankName) {
      let bankNameElement = document.getElementById("bankName");
      bankNameElement.focus();
    } else if (formik.errors && formik.errors.account_number) {
      let accNumberElement = document.getElementById("account_number");
      accNumberElement.focus();
    } else if (formik.errors && formik.errors.account_ifsc) {
      let ifscElement = document.getElementById("account_ifsc");
      ifscElement.focus();
    } else if (formik.errors && formik.errors.account_branch) {
      let branchNameElement = document.getElementById("account_branch");
      branchNameElement.focus();
    }
  }, [count]);

  // useEffect(() => {
  //   setLocalizationText(
  //     props.auth.user.VendorUser.country_code +
  //       props.auth.user.VendorUser.country
  //   );
  // }, [props.onboarding.bankName]);

  useEffect(() => {
    if (
      props &&
      props.subscriptionData &&
      props.subscriptionData.addedAccounts
    ) {
      setBankData(
        props && props.subscriptionData && props.subscriptionData.addedAccounts
      );

      let flagForAccountPurpose = true;
      for (let i = 0; i < props.subscriptionData.addedAccounts.length; i++) {
        if (
          props.subscriptionData.addedAccounts[i].account_purpose === "TIPS"
        ) {
          flagForAccountPurpose = false;
        }
      }
      setShowForm(flagForAccountPurpose);
    } else {
      setShowForm(true);
    }
  }, [props.subscriptionData]);
  const [showDetails, setShowDetails] = useState(false);
  const handleShowDetails = () => setShowDetails(true);
  const handleCloseDetails = () => setShowDetails(false);

  return (
    <React.Fragment>
      {!props.auth.loader ? (
        <>
          <div className="container-fluid">
            <div className="row">
              <div className="left-side-panel">
                <LeftSideNavigation />
              </div>

              <div className="top-panel">
                <TopNavigationBarMobile displayLeft="logo" />
              </div>
              <div className="right-side-panel">
                <RightSideNavigation
                  leftText="vendorReview"
                  backButtonLink="/edit-ordering-fastfood-subscription"
                  displayText="Back"
                />
                <div className="col-6 bg-transparent pt-md-0 pt-lg-0 pt-xl-0">
                  <div className="mb-4">
                    <TopTextReusableComponent
                      headingText="Separate Bank Account for Tips and Gratuity"
                      headingParagraph="(Enter the Bank Details where the amount for Tips paid by customers would be credited * after applicable charges as per MoU)"
                      displayEdit={state.editButton}
                      // onClickEdit={editClick}
                    />
                  </div>
                  {showForm ? (
                    <div>
                      <div className="bank_and_other_details_onboarding_main">
                        <div className="f16-700 mt-4">Bank Account Info</div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 p-0">
                          <NewInputText
                            controlClass={"bankName"}
                            extraClass={`mb-1 mt-4 ${
                              formik.errors.bankName && formik.touched.bankName
                                ? "enError"
                                : ""
                            }`}
                            inputType="text"
                            helpTextDisplay={true}
                            helperTextBottom="Enter Name on the Account"
                            onKeyDown={InputCharNumSpaceFunc}
                            maxLength={120}
                            labelText="Name on Bank Account"
                            name="bankName"
                            onChange={formik.handleChange}
                            value={formik.values.bankName}
                            onFocusOut={formik.handleBlur}
                            // isInvalid={
                            //   formik.errors.bankName && formik.touched.bankName
                            // }
                          />
                          {formik.errors.bankName && formik.touched.bankName ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.bankName}
                            </div>
                          ) : null}
                        </div>
                        <div className="f16-700 mt-4 mb-2">Account Type?</div>
                        {/* {localizationText.length > 0 ? (
                          <div className="checkbox-main-div">
                            <div className="checkbox-bank-account justify-content-start">
                              <label className="enRadioWithText mr-3">
                                <span className="f16-500">
                                  {localizationText.length > 0 ? (
                                    <>
                                      {country[localizationText].accountTypeOne}
                                    </>
                                  ) : null}
                                </span>

                                <input
                                  type="radio"
                                  name="account_type"
                                  value={
                                    localizationText.length > 0
                                      ? country[localizationText]
                                          .accountTypeOneCurrent
                                      : null
                                  }
                                  onChange={formik.handleChange}
                                  checked={
                                    formik.values.account_type ===
                                    country[localizationText]
                                      .accountTypeOneCurrent
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                              <label className="enRadioWithText f18-500">
                                <span className="f16-500">
                                  {localizationText.length > 0 ? (
                                    <>
                                      {country[localizationText].accountTypeTwo}
                                    </>
                                  ) : (
                                    <> </>
                                  )}
                                </span>
                                <input
                                  type="radio"
                                  name="account_type"
                                  value={
                                    localizationText.length > 0
                                      ? country[localizationText].accountTypeTwo
                                      : null
                                  }
                                  onChange={formik.handleChange}
                                  checked={
                                    formik.values.account_type ===
                                    country[localizationText].accountTypeTwo
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                            </div>
                            {formik.errors.account_type &&
                            formik.touched.account_type ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.account_type}
                              </div>
                            ) : null}
                          </div>
                        ) : (
                          <> </>
                        )} */}
                        {localizationText.length > 0 ? (
                          <div className="checkbox-main-div">
                            <div className="checkbox-bank-account justify-content-start">
                              <label className="enRadioWithText mr-3">
                                <span className="f16-500">
                                  {localizationText.length > 0 ? (
                                    <>
                                      {country[localizationText].accountTypeOne}
                                    </>
                                  ) : null}
                                </span>

                                <input
                                  type="radio"
                                  name="account_type"
                                  value={
                                    localizationText.length > 0
                                      ? country[localizationText]
                                          .accountTypeOneCurrent
                                      : null
                                  }
                                  onChange={formik.handleChange}
                                  checked={
                                    formik.values.account_type ===
                                    country[localizationText]
                                      .accountTypeOneCurrent
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                              <label className="enRadioWithText f18-500">
                                <span className="f16-500">
                                  {localizationText.length > 0 ? (
                                    <>
                                      {country[localizationText].accountTypeTwo}
                                    </>
                                  ) : (
                                    <> </>
                                  )}
                                </span>
                                <input
                                  type="radio"
                                  name="account_type"
                                  value={
                                    localizationText.length > 0
                                      ? country[localizationText]
                                          .accountTypeTwoSaving
                                      : null
                                  }
                                  onChange={formik.handleChange}
                                  checked={
                                    formik.values.account_type ===
                                    country[localizationText]
                                      .accountTypeTwoSaving
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                            </div>
                            {formik.errors.account_type &&
                            formik.touched.account_type ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.account_type}
                              </div>
                            ) : null}
                          </div>
                        ) : (
                          <> </>
                        )}
                        <NewInputText
                          controlClass={"account_number"}
                          extraClass={`mb-1 mt-4 ${
                            formik.errors.account_number &&
                            formik.touched.account_number
                              ? "enError"
                              : ""
                          }`}
                          inputType="text"
                          onInput={maxLengthCheck}
                          maxLength={20}
                          onKeyDown={InputNumberFunc}
                          labelText="Account Number"
                          name="account_number"
                          onChange={formik.handleChange}
                          value={formik.values.account_number}
                          onFocusOut={formik.handleBlur}
                          // isInvalid={
                          //   formik.errors.account_number &&
                          //   formik.touched.account_number
                          // }
                        />
                        {formik.errors.account_number &&
                        formik.touched.account_number ? (
                          <div className="f11-400 text-danger">
                            {formik.errors.account_number}
                          </div>
                        ) : (
                          <div className="f11-400 opacity5">
                            Account Number (6 Digits to Max 20 digits)
                          </div>
                        )}
                        <NewInputText
                          controlClass={"re_account_number"}
                          extraClass={`mb-1 mt-4 ${
                            formik.errors.account_number &&
                            formik.touched.account_number
                              ? "enError"
                              : ""
                          }`}
                          inputType="text"
                          onInput={maxLengthCheck}
                          maxLength={20}
                          onKeyDown={InputNumberFunc}
                          labelText="Re-Enter Account Number"
                          name="re_account_number"
                          onChange={formik.handleChange}
                          value={formik.values.re_account_number}
                          onFocusOut={formik.handleBlur}
                          // isInvalid={
                          //   formik.errors.account_number &&
                          //   formik.touched.account_number
                          // }
                        />
                        {formik.errors.re_account_number &&
                        formik.touched.re_account_number ? (
                          <div className="f11-400 text-danger">
                            {formik.errors.re_account_number}
                          </div>
                        ) : (
                          <div className="f11-400 opacity5">
                            Account Number (6 Digits to Max 20 digits)
                          </div>
                        )}
                        <NewInputText
                          controlClass={"email"}
                          extraClass={`mb-1 mt-4 ${
                            formik.errors.email && formik.touched.email
                              ? "enError"
                              : ""
                          }`}
                          inputType="text"
                          labelText="Email"
                          helpTextDisplay={true}
                          helperTextBottom="Email"
                          name="email"
                          onChange={formik.handleChange}
                          value={formik.values.email}
                          onFocusOut={formik.handleBlur}
                          // isInvalid={
                          //   formik.errors.account_number &&
                          //   formik.touched.account_number
                          // }
                        />
                        {formik.errors.email && formik.touched.email ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.email}
                          </div>
                        ) : null}
                        <NewInputText
                          controlClass={"account_ifsc"}
                          extraClass={`mb-1 mt-4 ${
                            formik.errors.account_ifsc &&
                            formik.touched.account_ifsc
                              ? "enError"
                              : ""
                          }`}
                          inputType="text"
                          onKeyDown={InputCharNumFunc}
                          maxLength={11}
                          labelText="IFSC Code"
                          helpTextDisplay={true}
                          helperTextBottom="IFSC Code (11-Character Code)"
                          name="account_ifsc"
                          onChange={formik.handleChange}
                          value={formik.values.account_ifsc}
                          onFocusOut={formik.handleBlur}
                          // isInvalid={
                          //   formik.errors.account_ifsc && formik.touched.account_ifsc
                          // }
                        />
                        {formik.errors.account_ifsc &&
                        formik.touched.account_ifsc ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.account_ifsc}
                          </div>
                        ) : null}
                        <NewInputText
                          controlClass={"account_branch"}
                          extraClass={`mb-1 mt-4 ${
                            formik.errors.account_branch &&
                            formik.touched.account_branch
                              ? "enError"
                              : ""
                          }`}
                          name="branchName"
                          inputType="text"
                          onKeyDown={InputCharacterCheck}
                          maxLength={35}
                          labelText="Branch Name"
                          helpTextDisplay={true}
                          helperTextBottom="Branch Name"
                          name="account_branch"
                          onChange={formik.handleChange}
                          value={formik.values.account_branch}
                          onFocusOut={formik.handleBlur}
                          // isInvalid={
                          //   formik.errors.account_branch && formik.touched.account_branch
                          // }
                        />
                        {formik.errors.account_branch &&
                        formik.touched.account_branch ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.account_branch}
                          </div>
                        ) : null}
                      </div>

                      <div className="col-12 bank-error-message-spacing p-0 mb-3">
                        {/* <BankDetailsUploadComponent
//               title="Upload Documents*"
//               smallTitle="(Upload bank related documents)"
//               onDrop={this.onDropBank}
//               imageExtension={[".jpg", ".gif", ".png", ".jpeg", ".pdf"]}
//             /> */}
                        <SimpleReactLightbox>
                          <MultipleImageUploadComponent
                            title="Upload Relevant Documents"
                            smallTitle="(Upload supporting documents such as a Cancelled Cheque, Bank Statement as applicable) - You may receive a call for KYC and Confirmation"
                            onChange={bankUploadMultipleFiles}
                            //stateValue={docs}
                            stateValue={formik.values.docs}
                            newUploaded={
                              restaurant_pictures_new
                                ? restaurant_pictures_new
                                : []
                            }
                            combined={combined}
                            onCompleteUploadMultipleCrop={
                              onCompleteUploadMultipleCrop
                            }
                            removeImage={bankDocMultipleRemove}
                            // loader={state.bankImageLoader}
                            accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                          />
                        </SimpleReactLightbox>
                        {formik.errors.docs && formik.touched.docs ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.docs}
                          </div>
                        ) : null }
                      </div>

                      <div className="onboarding-map-setup-screen-autodetect-button">
                        <ReusableOnboardingLink
                          buttonTitle="Back Button"
                          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                          buttonText="Back"
                          link="/edit-ordering-fastfood-subscription/separate-bank-account"
                        />
                        <ReusableOnboardingButton
                          buttonTitle="Done Button"
                          buttonClass={
                            Object.keys(formik.errors).length !== 0
                              ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray"
                              : "onboarding_button_link_reusable onboarding_button_link_reusable_red"
                          }
                          // disabled={
                          //   formik.values.bankName === "" ||
                          //   formik.values.account_type === "" ||
                          //   formik.values.account_branch === "" ||
                          //   (formik.values.account_number === "" &&
                          //     formik.values.account_number.length <= 11) ||
                          //   (formik.values.account_number.account_ifsc === "" &&
                          //     formik.values.account_number.account_ifsc.length <= 11) ||
                          //   formik.values.docs.length === 0
                          //     ? true
                          //     : false
                          // }
                          buttonText="Done"
                          buttonType="button"
                          onClick={() => onClickDone()}
                        />
                      </div>
                      {/* <div className="onboarding-map-setup-screen-autodetect-button pt-4">
                    <ReusableOnboardingLink
                      buttonTitle="Back Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                      buttonText="Back"
                      link="/casual-fine-dining/ordering/bankaccount"
                    />
                    <ReusableOnboardingButton
                      buttonTitle="Next Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                      buttonText="Done"
                      buttonType="Submit"
                    />
                  </div> */}
                    </div>
                  ) : (
                    <> </>
                  )}
                  <div
                    className="d-flex align-items-center text-red f14-500 cursor my-4"
                    onClick={handleShowTaxSurcharges}
                  >
                    Show added Bank Accounts <KeyboardArrowDownIcon />
                  </div>
                  {showTaxSurcharges.showTaxSurcharges && (
                    <React.Fragment>
                      <Row>
                        <Col md={2} className="pb-4">
                          <div className="f11-400">No.</div>
                        </Col>
                        <Col md={3} className="pb-4">
                          <div className="f11-400">Name on Account</div>
                        </Col>
                        <Col md={3} className="pb-4">
                          <div className="f11-400">Type of Account</div>
                        </Col>
                        <Col md={2} className="pb-3">
                          <div className="f11-400">Action</div>
                        </Col>
                        <Col md={2} className="pb-3">
                          <button
                            type="button"
                            className={
                              "add-button-icon-reusable add-button-icon-reusable-blue"
                            }
                            onClick={handleShowDetails}
                          >
                            See more
                          </button>
                          <Modal
                            show={showDetails}
                            onHide={handleCloseDetails}
                            centered
                            size="xl"
                          >
                            <Modal.Header className="px-4 border-0" closeButton>
                              <Modal.Title className="f20-700">
                                Show added Bank Accounts
                              </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="px-4">
                              {bankData.map((bank, index) => (
                                <React.Fragment key={index}>
                                  {bank.account_purpose === "ORDERING" ? (
                                    <> </>
                                  ) : (
                                    <div className="enGrayBorderBox px-3 mb-3">
                                      <Row>
                                        <Col lg={3} className="py-2">
                                          <div className="d-flex">
                                            <div>
                                              <div className="f11-400 pb-2">
                                                No.
                                              </div>
                                              <div className="f11-700">1</div>
                                            </div>
                                            <div className="pl-2">
                                              <div className="f11-400 pb-2">
                                                Name on Account
                                              </div>
                                              <div className="f11-700">
                                                {bank.bankName}
                                              </div>
                                            </div>
                                          </div>
                                        </Col>
                                        <Col lg={3} className="py-2">
                                          <div className="f11-400 pb-2">
                                            Type of Account
                                          </div>
                                          <div className="f11-700">
                                            {bank.account_type}
                                          </div>
                                        </Col>
                                        <Col lg={3} className="py-2">
                                          <div className="f11-400 pb-2">
                                            Account Number/ IFSC Code
                                          </div>
                                          <div className="f11-700">
                                            {bank.account_number}
                                          </div>
                                          <div className="f9-400 mb-1">
                                            Account Number
                                          </div>
                                          <div className="f11-700">
                                            {bank.account_ifsc}
                                          </div>
                                          <div className="f9-400">
                                            IFSC Code
                                          </div>
                                        </Col>
                                        <Col lg={3} className="py-2">
                                          <div className="f11-400 pb-2">
                                            Transaction Group
                                          </div>
                                          <div className="f11-700">
                                            Scan & Pay
                                          </div>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col md={12}>
                                          <hr />
                                        </Col>
                                        <Col lg={3} className="py-2">
                                          <div className="f11-400 pb-2">
                                            Branch Name / Documents
                                          </div>
                                          <div className="f11-700">
                                            {bank.account_branch}
                                          </div>
                                        </Col>
                                        <Col lg={6} className="py-2">
                                          <SimpleReactLightbox>
                                            <MultipleImageUploadShowComponent
                                              imgSrc={bank.docs}
                                            />
                                          </SimpleReactLightbox>
                                        </Col>
                                        <Col lg={3} className="py-2">
                                          {/* <IconButton
                                            className="mr-2 p-0"
                                            onClick={() =>
                                              setDataToFrorm(bank, index)
                                            }
                                          >
                                            <Image
                                              src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                              alt="add"
                                              title="add"
                                              className="w-20px"
                                            />
                                          </IconButton> */}
                                          <IconButton
                                            className="p-0"
                                            onClick={() =>
                                              handleShowBAccount(index)
                                            }
                                          >
                                            <Image
                                              src={require("../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                              alt="add"
                                              title="add"
                                              className="w-20px"
                                            />
                                          </IconButton>
                                        </Col>
                                      </Row>
                                    </div>
                                  )}
                                </React.Fragment>
                              ))}
                            </Modal.Body>
                          </Modal>
                        </Col>
                      </Row>
                      {bankData.map((bank, index) => (
                        <React.Fragment key={index}>
                          {bank.account_purpose === "ORDERING" ? (
                            <> </>
                          ) : (
                            <Row className="align-items-center">
                              <Col md={2} className="pb-4">
                                <div className="f11-700">1</div>
                              </Col>
                              <Col md={3} className="pb-4">
                                <div className="f11-700">{bank.bankName}</div>
                              </Col>
                              <Col md={3} className="pb-4">
                                <div className="f11-700">
                                  {bank.account_type}
                                </div>
                              </Col>
                              <Col md={2} className="pb-3">
                                <div className="d-flex align-itmes-center">
                                  {/* <button
                                    className="editIcon-blue"
                                    type="button"
                                    onClick={() => setDataToFrorm(bank, index)}
                                  >
                                    <SVG
                                      src={require("../../../../../../../../assets/images/UserManagement/pencil.svg")}
                                    />
                                  </button> */}
                                  <AddButtonIconComponent
                                    fontIcon="fa fa-trash-o"
                                    colorCss="delete"
                                    onClick={() => handleShowBAccount(index)}
                                  />
                                </div>
                              </Col>
                            </Row>
                          )}
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
          </div>
          <Modal show={showDeleteAccount} onHide={handleCloseAccount} centered>
            <Modal.Header className="py-0 pt-2 border-0" closeButton>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body className="f16-500">
              Are you sure to delete bank account ?
            </Modal.Body>
            <Modal.Footer className="justify-content-start border-0">
              <Button
                variant="outline-secondary"
                className="btn-lg mr-4 px-5"
                onClick={handleCloseAccount}
              >
                No
              </Button>
              <Button
                variant="danger"
                className="btn-lg px-5"
                //onClick={() => props.yesClicked(handleCloseBlockUser)}
                onClick={() => onClickDeleteAccount()}
              >
                Yes
              </Button>
            </Modal.Footer>
          </Modal>{" "}
        </>
      ) : (
        <AmealioLoader />
      )}
    </React.Fragment>
  );
};

EditFastFoodSeparateBankAccount.propTypes = {
  auth: PropTypes.object.isRequired,
  razor_create_fund_account: PropTypes.func.isRequired,
  razor_validate_fund_account: PropTypes.func.isRequired,
  razor_create_sub_merchant_account: PropTypes.func.isRequired,
  update_new_subscription_for_vendor: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding && state.onboarding.restaurantDetails,
  subscription:
    state.onboarding && state.onboarding.onboard_subscription_details,
  subscriptionData:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.fast_food_dining_status &&
    state.onboarding.onboard_subscription_details.fast_food_dining_status
      .ordering &&
    state.onboarding.onboard_subscription_details.fast_food_dining_status
      .ordering.maintain_separate_bank,
  allSubscriptionsData:
    state.onboarding && state.onboarding.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
  razor_create_fund_account,
  razor_validate_fund_account,
  razor_create_sub_merchant_account,
})(EditFastFoodSeparateBankAccount);
